<a href="https://svs.at" class="flex no-underline bg-surface-action-primary gap-sm py-xs px-sm text-white cursor-pointer">
  <core-icon icon="arrow_back"></core-icon>
  Zurück zur SVS Website
</a>
